export const technicalSheet = {
	sections: {
		generalInfo: {
			title: "INFORMAÇÕES GERAIS",
			preparationTime: {
				label: "Tempo de preparo",
				placeholder: "00 minutos",
				unit: "minutos",
			},
		},
		ingredients: {
			title: "INGREDIENTES",
			addButton: "Adicionar a ficha",
			emptyState: {
				title: "Nenhum insumo adicionado",
				message: "Adicione insumos para compor a ficha técnica",
			},
			inline: {
				product: "Produto/Insumo",
				quantity: "Quantidade",
				loss: "Perdas",
			},
			columns: {
				product: "PRODUTO/INSUMO",
				quantity: "QUANTIDADE",
				loss: "PERDA",
				yield: "RENDIMENTO",
				unitCost: "CUSTO UNITÁRIO",
				unitCostTooltip: "Custo unitário é média de todos os custos do produto",
				totalCost: "CUSTO TOTAL",
				totalCostTooltip: "Custo total é o custo médio de todos os produtos",
			},
			validation: {
				selectProduct: "Selecione um insumo",
				addQuantity: "Adicione uma quantidade",
				lossGreaterThanQuantity: "O valor de perda não pode ser maior que a quantidade",
				atLeastOneIngredient: "Adicione ao menos um insumo à ficha técnica",
				quantityGreaterThanZero: "O valor deve ser maior que 0",
			},
		},
	},
	summary: {
		salePrice: "Preço de venda",
		totalCost: "Custo total",
		totalCostTooltip: "Custo total é o custo médio de todos os produtos",
		profitMargin: "Margem de lucro",
		cmv: "CMV",
	},
	actions: {
		delete: "Excluir ficha técnica",
		exportPdf: "Exportar PDF",
		deleteConfirmation: {
			title: "Excluir ficha técnica",
			description:
				"Ao confirmar a ação você exclui permanentemente a ficha técnica. Deseja continuar?",
			confirm: "Sim, desejo excluir",
			cancel: "Cancelar",
		},
		notifications: {
			deleteSuccess: "Ficha técnica removida com sucesso",
			deleteError: "Erro ao remover a ficha técnica",
		},
	},
};
